import { Box, Button, Modal, ModalDialog, Stack, Typography, CircularProgress } from "@mui/joy";
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { useContext, useEffect, useState } from "react";
import { LayoutContext } from "../../context";
import { APITestPushNotification } from "../../api";

export default function ModalTestPush({ open, onSuccess }) {
    const { tokenEmployee, subscribeUserToPush } = useContext(LayoutContext);
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState(false);

    const sendTest = async () => {
        if (!tokenEmployee) return;
        setLoading(true);
        setError(false);
        try {
            await APITestPushNotification(tokenEmployee);
            setSent(true);
        } catch (e) {
            console.error("Ошибка отправки теста:", e);
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    // Автоматически отправляем тест при открытии модалки
    useEffect(() => {
        if (open) {
            setSent(false);
            setError(false);
            sendTest();
        }
    }, [open]);

    const handleRetry = async () => {
        setLoading(true);
        setSent(false);
        setError(false);
        try {
            // Удаляем старую подписку в браузере
            const reg = await navigator.serviceWorker.ready;
            const oldSub = await reg.pushManager.getSubscription();
            if (oldSub) await oldSub.unsubscribe();

            // Пересоздаём — это снова вызовет sendSubscriptionToServer
            // и откроет эту же модалку, но мы уже в ней, просто шлём тест заново
            await subscribeUserToPush(tokenEmployee);
            await APITestPushNotification(tokenEmployee);
            setSent(true);
        } catch (e) {
            console.error("Ошибка при повторной попытке:", e);
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal open={open} sx={{ zIndex: 10030 }}>
            <ModalDialog
                sx={{
                    maxWidth: 360,
                    width: '90vw',
                    borderRadius: 'xl',
                    p: 3,
                    textAlign: 'center'
                }}
            >
                <Stack spacing={2.5} alignItems="center">
                    <Box>
                        {loading
                            ? <CircularProgress size="lg" />
                            : error
                                ? <Box sx={{ fontSize: 48 }}>⚠️</Box>
                                : <NotificationsActiveRoundedIcon sx={{ fontSize: 48, color: 'primary.500' }} />
                        }
                    </Box>

                    <Typography level="h4" fontWeight={700}>
                        Проверка уведомлений
                    </Typography>

                    <Typography level="body-md" sx={{ color: 'text.secondary' }}>
                        {loading
                            ? 'Отправляем тестовое уведомление...'
                            : error
                                ? 'Не удалось отправить тест. Попробуйте повторить.'
                                : 'Тестовое уведомление отправлено! Оно должно появиться на вашем экране через несколько секунд.'
                        }
                    </Typography>

                    {!loading && (
                        <Stack spacing={1.5} sx={{ width: '100%' }}>
                            <Button
                                color="success"
                                variant="solid"
                                startDecorator={<CheckRoundedIcon />}
                                onClick={onSuccess}
                                sx={{ borderRadius: 'lg' }}
                            >
                                Да, всё пришло!
                            </Button>
                            <Button
                                color="neutral"
                                variant="soft"
                                startDecorator={<RefreshRoundedIcon />}
                                onClick={handleRetry}
                                sx={{ borderRadius: 'lg' }}
                            >
                                Нет, повторить
                            </Button>
                        </Stack>
                    )}
                </Stack>
            </ModalDialog>
        </Modal>
    );
}
